$(() => {
  $.fn.isBefore = function (el) {
    return this.nextAll().filter(el).length !== 0;
  };
  const tabKey = 9;
  const enterKey = 13;
  const escKey = 27;
  // elements
  const topNav = '.nav-1';
  const bottomNav = '.nav-2';
  const navBarToggler = '.navbar-toggler';
  const $lastFocusableOnMobile = $('.last-focusable-drpdn-mob');
  const navLinkTop = '.nav-link-top';
  const lastFocusableMobDropdownLink = '.dropdown-item:last';
  const allNavMobLinks = 'nav a:not(.dropdown-item):not(.dropdown-toggle), nav button';
  const $navbar = $('#navbar');
  const lockBody = function () {
    $('html, body').css({
      overflow: 'hidden',
      height: '100%',
    });
  };
  const unlockBody = function () {
    $('html, body, #main').removeAttr('style');
  };
  const changeElementsPositionInDom = function (firstEl, secondEl) {
    if (!$(secondEl).isBefore(firstEl)) {
      $(firstEl).insertAfter($(secondEl));
    }
  };
  const isMobile = function () {
    if (window.innerWidth > 767) {
      return false;
    }
    return true;
  };

  $(window).on('resize', () => {
    // to switch top and bottom nav sections if they were switched on mobile for accessibility
    if (!isMobile()) {
      changeElementsPositionInDom(bottomNav, topNav);
      unlockBody();
    }
  });
  // to switch positions of top and bottom nav sections on tab key press, need for accessibility
  $(navBarToggler).on('keydown', e => {
    if (isMobile() && e.keyCode == enterKey) {
      changeElementsPositionInDom(topNav, bottomNav);
    }
  });

  // too loop through links on mobile menu
  $lastFocusableOnMobile.find(navLinkTop).on('keydown', e => {
    if (isMobile() && e.keyCode == tabKey) {
      if (!$lastFocusableOnMobile.hasClass('show')) {
        $(navBarToggler).focus();
        e.stopPropagation();
        e.preventDefault();
      }
    }
  });
  $lastFocusableOnMobile.find(lastFocusableMobDropdownLink).on('keydown', e => {
    if (isMobile() && e.keyCode == escKey) {
      $(navBarToggler).focus();
      e.preventDefault();
      e.stopPropagation();
    }
  });
  // to close menu if any of the links get esc key press
  $(allNavMobLinks).on('keydown', e => {
    if (isMobile() && e.keyCode == escKey) {
      $(navBarToggler).click().focus();
      e.preventDefault();
      e.stopPropagation();
    }
  });

  $navbar.on('shown.bs.collapse', () => {
    lockBody();
  }).on('hidden.bs.collapse', () => {
    unlockBody();
  });
});
